import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { useDepositLedgerSelectedDate } from '../context/DepositLedgerFilterContext';

export const useDepositLedgerBalanceQuery = () => {
    const enterpriseId = useCurrentEnterpriseId();
    const { selectedDate } = useDepositLedgerSelectedDate();

    return useRepositoryQuery(
        'depositledger',
        'getBalance',
        {
            enterpriseId,
            date: selectedDate,
        },
        {
            enabled: !!enterpriseId,
            staleTime: 5000,
            refetchOnWindowFocus: true,
            refetchOnMount: true,
        }
    );
};
